import React from "react";
import { Card } from "./ui/card";
import { Target, Users, TrendingUp } from "lucide-react";

const About = () => {
  const highlights = [
    {
      icon: Target,
      title: "17+ Years Experience",
      description: "Delivering proven SEO strategies since 2008"
    },
    {
      icon: Users,
      title: "B2B & B2C Expertise",
      description: "Working with businesses of all sizes and sectors"
    },
    {
      icon: TrendingUp,
      title: "Organic Growth Focus",
      description: "Driving sustainable traffic and conversions"
    }
  ];

  return (
    <section id="about" className="py-16 sm:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            About Me
          </h2>
          <p className="text-lg sm:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed px-4">
            I'm an SEO specialist who helps businesses achieve top search rankings and sustainable growth. With expertise in Local and National SEO, GEO optimization, and AI-powered marketing, I transform online visibility into real business results.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mt-12 sm:mt-16">
          {highlights.map((item, index) => {
            const Icon = item.icon;
            return (
              <Card
                key={index}
                className="p-8 border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 bg-white"
              >
                <div className="w-14 h-14 bg-emerald-100 rounded-lg flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-emerald-600" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {item.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;